export class StaticContextField {

    private readonly staticModelValue: any; // attentiona! this must be an object. otherwise we lose the reference!
    private readonly fieldReferenceDescription: DisguiseDto.ContextFieldReferenceDescription;

    constructor(fieldReferenceDescription: DisguiseDto.ContextFieldReferenceDescription,
                staticModelValue: any) {
        this.fieldReferenceDescription = fieldReferenceDescription;
        this.staticModelValue = staticModelValue;
    }

    public collectKeyValuePair() {
        return {
            key: this.fieldReferenceDescription.endpointKeyPath || '',
            value: this.staticModelValue
        };
    }

}
